import { render, staticRenderFns } from "./DialogCreateLift.vue?vue&type=template&id=3b892cbe"
import script from "./DialogCreateLift.vue?vue&type=script&lang=js"
export * from "./DialogCreateLift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports